import SoraLove from 'src/assets/img/realtalk/sora_top.webp'
import MinatoLove from 'src/assets/img/realtalk/minato_top.webp'
import RenLove from 'src/assets/img/realtalk/ren_top.webp'
import ShoLove from 'src/assets/img/realtalk/sho_top.webp'
import SyunLove from 'src/assets/img/realtalk/syun_top.webp'
import RinLove from 'src/assets/img/realtalk/rin_top.png'
import RitsuLove from 'src/assets/img/realtalk/ritsu_top.png'
import ReiLove from 'src/assets/img/realtalk/rei_top.png'
import SakuraLove from 'src/assets/img/realtalk/sakura_top.png'
import JinLove from 'src/assets/img/realtalk/jin_top.png'
import ItsukiLove from 'src/assets/img/realtalk/itsuki_top.png'
import NagiLove from 'src/assets/img/realtalk/nagi_top.png'
import SoraSub from 'src/assets/img/realtalk/sora_bg.svg'
import SyunSub from 'src/assets/img/realtalk/suyn_bg.svg'
import SakuraSub from 'src/assets/img/realtalk/sakura_bg.svg'
import ShoSub from 'src/assets/img/realtalk/sho_bg.svg'
import RenSub from 'src/assets/img/realtalk/ren_bg.svg'
import RinSub from 'src/assets/img/realtalk/rin_bg.svg'
import ItsukiSub from 'src/assets/img/realtalk/itsuki_bg.svg'
import JinSub from 'src/assets/img/realtalk/jin_bg.svg'
import RitsuSub from 'src/assets/img/realtalk/ritsu_bg.svg'
import NagiSub from 'src/assets/img/realtalk/nagi_bg.svg'
import ReiSub from 'src/assets/img/realtalk/rei_bg.svg'
import MinatoSub from 'src/assets/img/realtalk/minato_bg.svg'
import SoraBtn from 'src/assets/img/realtalk/button_sora.png'
import SyunBtn from 'src/assets/img/realtalk/button_syun.png'
import ShoBtn from 'src/assets/img/realtalk/button_sho.png'
import RenBtn from 'src/assets/img/realtalk/button_ren.png'
import MinatoBtn from 'src/assets/img/realtalk/button_minato.png'
import SakuraBtn from 'src/assets/img/realtalk/button_sakura.png'
import RinBtn from 'src/assets/img/realtalk/button_rin.png'
import JinBtn from 'src/assets/img/realtalk/button_jin.png'
import RitsuBtn from 'src/assets/img/realtalk/button_ritsu.png'
import ReiBtn from 'src/assets/img/realtalk/button_rei.png'
import ItsukiBtn from 'src/assets/img/realtalk/button_itsuki.png'
import NagiBtn from 'src/assets/img/realtalk/button_nagi.png'
import iconCharacterMina from 'src/assets/img/realtalk/realtalk_sd_minato.png'
import iconCharacterRen from 'src/assets/img/realtalk/realtalk_sd_ren.png'
import iconCharacterSho from 'src/assets/img/realtalk/realtalk_sd_sho.png'
import iconCharacterSora from 'src/assets/img/realtalk/realtalk_sd_sora.png'
import iconCharacterSyun from 'src/assets/img/realtalk/realtalk_sd_syun.png'
import iconCharacterRin from 'src/assets/img/realtalk/realtalk_sd_rin.png'
import iconCharacterRitsu from 'src/assets/img/realtalk/realtalk_sd_ritsu.png'
import iconCharacterRei from 'src/assets/img/realtalk/realtalk_sd_rei.png'
import iconCharacterSakura from 'src/assets/img/realtalk/realtalk_sd_sakura.png'
import iconCharacterJin from 'src/assets/img/realtalk/realtalk_sd_jin.png'
import iconCharacterItsuki from 'src/assets/img/realtalk/realtalk_sd_itsuki.png'
import iconCharacterNagi from 'src/assets/img/realtalk/realtalk_sd_nagi.png'
import SoraLeft from 'src/assets/img/gacha/sora_left.png'
import MinatoLeft from 'src/assets/img/gacha/minato_left.png'
import SyunLeft from 'src/assets/img/gacha/syun_left.png'
import RenLeft from 'src/assets/img/gacha/ren_left.png'
import ShoLeft from 'src/assets/img/gacha/sho_left.png'
import RinLeft from 'src/assets/img/gacha/rin_left.png'
import JinLeft from 'src/assets/img/gacha/jin_left.png'
import RitsuLeft from 'src/assets/img/gacha/ritsu_left.png'
import ReiLeft from 'src/assets/img/gacha/rei_left.png'
import NagiLeft from 'src/assets/img/gacha/nagi_left.png'
import SakuraLeft from 'src/assets/img/gacha/sakura_left.png'
import ItsukiLeft from 'src/assets/img/gacha/itsuki_left.png'

const characterConfig = {
  1: {
    imageActive: SoraLove,
    imageGray: SoraSub,
    imgIcon: iconCharacterSora,
    imgButton: SoraBtn,
    imgLeft: SoraLeft
  },
  2: {
    imageActive: MinatoLove,
    imageGray: MinatoSub,
    imgIcon: iconCharacterMina,
    imgButton: MinatoBtn,
    imgLeft: MinatoLeft
  },
  3: {
    imageActive: RenLove,
    imageGray: RenSub,
    imgIcon: iconCharacterRen,
    imgButton: RenBtn,
    imgLeft: RenLeft
  },
  4: {
    imageActive: ShoLove,
    imageGray: ShoSub,
    imgIcon: iconCharacterSho,
    imgButton: ShoBtn,
    imgLeft: ShoLeft
  },
  5: {
    imageActive: SyunLove,
    imageGray: SyunSub,
    imgIcon: iconCharacterSyun,
    imgButton: SyunBtn,
    imgLeft: SyunLeft
  },
  12: {
    imageActive: RinLove,
    imageGray: RinSub,
    imgIcon: iconCharacterRin,
    imgButton: RinBtn,
    imgLeft: RinLeft
  },
  13: {
    imageActive: RitsuLove,
    imageGray: RitsuSub,
    imgIcon: iconCharacterRitsu,
    imgButton: RitsuBtn,
    imgLeft: RitsuLeft
  },
  14: {
    imageActive: ReiLove,
    imageGray: ReiSub,
    imgIcon: iconCharacterRei,
    imgButton: ReiBtn,
    imgLeft: ReiLeft
  },
  8: {
    imageActive: SakuraLove,
    imageGray: SakuraSub,
    imgIcon: iconCharacterSakura,
    imgButton: SakuraBtn,
    imgLeft: SakuraLeft
  },
  9: {
    imageActive: JinLove,
    imageGray: JinSub,
    imgIcon: iconCharacterJin,
    imgButton: JinBtn,
    imgLeft: JinLeft
  },
  10: {
    imageActive: ItsukiLove,
    imageGray: ItsukiSub,
    imgIcon: iconCharacterItsuki,
    imgButton: ItsukiBtn,
    imgLeft: ItsukiLeft
  },
  11: {
    imageActive: NagiLove,
    imageGray: NagiSub,
    imgIcon: iconCharacterNagi,
    imgButton: NagiBtn,
    imgLeft: NagiLeft
  }
}

export const characterSlide = (data) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return
  }
  return data.map((item) => {
    const config = characterConfig[item]
    return config ? { ...item, ...config, id: item, unreadTotal: 0 } : item
  })
}
